import { cmsCopyLoaded } from '@actions/cms.action';
import {
  resourceGetCurrenciesSuccess,
  resourceGetAllResourcesSuccess,
  resourceGetCountriesSuccess,
  resourceGetCulturesSuccess,
  resourceGetPaymentMethodsSuccess,
  resourceGetGendersSuccess,
  resourceGetSuffixesSuccess,
  resourceGetProvinceStatesSuccess,
  resourceGetTimeZonesSuccess,
} from '@actions/resource.action';
import { CmsKeys } from '@constants/cms.constants';
import { AppCopy, CountryPhoneCode } from '@models/cms/app.model';
import { CountryResource } from '@models/resources/country.model';
import { CultureResource } from '@models/resources/culture.model';
import { CurrencyResource } from '@models/resources/currency.model';
import { GenderResource } from '@models/resources/gender.model';
import { MonthResource } from '@models/resources/month.model';
import { PaymentMethodResource } from '@models/resources/payment-method.model';
import { ProvinceStateResource } from '@models/resources/province-state.model';
import { SuffixResource } from '@models/resources/suffix.model';
import { TimeZoneResource } from '@models/resources/time-zones.model';
import { Action, createReducer, on } from '@ngrx/store';

export interface State {
  countries: CountryResource[] | null;
  cultures: CultureResource[] | null;
  currencies: CurrencyResource[] | null;
  genders: GenderResource[] | null;
  months: MonthResource[] | null;
  paymentMethods: PaymentMethodResource[] | null;
  phoneCodes: CountryPhoneCode[] | null;
  provinceStates: ProvinceStateResource[] | null;
  suffixes: SuffixResource[] | null;
  timeZones: TimeZoneResource[] | null;
}

export const INITIAL_STATE: State = {
  months: null,
  genders: null,
  suffixes: null,
  countries: null,
  paymentMethods: null,
  currencies: null,
  cultures: null,
  phoneCodes: null,
  provinceStates: null,
  timeZones: null,
};

const reducer = createReducer(
  INITIAL_STATE,
  on(
    resourceGetAllResourcesSuccess,
    (currentState, action): State => ({
      ...currentState,
      genders: action.genders,
      suffixes: action.suffixes,
      countries: action.countries,
      paymentMethods: action.paymentMethods,
      currencies: action.currencies,
      cultures: action.cultures,
      provinceStates: action.provinceStates,
      timeZones: action.timeZones,
    }),
  ),
  on(
    resourceGetProvinceStatesSuccess,
    (currentState, action): State => ({
      ...currentState,
      provinceStates: action.provinceStates,
    }),
  ),
  on(
    resourceGetCurrenciesSuccess,
    (currentState, action): State => ({
      ...currentState,
      currencies: action.currencies,
    }),
  ),
  on(
    resourceGetCountriesSuccess,
    (currentState, action): State => ({
      ...currentState,
      countries: action.countries,
    }),
  ),
  on(
    resourceGetCulturesSuccess,
    (currentState, action): State => ({
      ...currentState,
      cultures: action.cultures,
    }),
  ),
  on(cmsCopyLoaded, (currentState, action): State => {
    if (action.key !== CmsKeys.App) {
      return currentState;
    }
    const appCopy = action.data as AppCopy;
    return {
      ...currentState,
      phoneCodes: appCopy.phoneCodes,
      months: appCopy.months,
    };
  }),
  on(
    resourceGetPaymentMethodsSuccess,
    (currentState, action): State => ({
      ...currentState,
      paymentMethods: action.paymentMethods,
    }),
  ),
  on(
    resourceGetGendersSuccess,
    (currentState, action): State => ({
      ...currentState,
      genders: action.genders,
    }),
  ),
  on(
    resourceGetSuffixesSuccess,
    (currentState, action): State => ({
      ...currentState,
      suffixes: action.suffixes,
    }),
  ),
  on(
    resourceGetTimeZonesSuccess,
    (currentState, action): State => ({
      ...currentState,
      timeZones: action.timeZones,
    }),
  ),
);

export const resourceReducer = (state: State, action: Action): State =>
  reducer(state, action);
